import { Injectable } from '@angular/core';

/** Costura fina sobre document.cookie — trocável por fake em teste. */
@Injectable({ providedIn: 'root' })
export class CookieAccess {
  read(): string {
    return document.cookie;
  }

  write(cookie: string): void {
    document.cookie = cookie;
  }
}
